<script lang="ts">
  import type { PageData } from './$types'
  import { FAQ_STRINGS } from './strings'
  import Faq from '$lib/components/Faq.svelte'
  import { StructuredData } from '@bruce/components'

  export let data: PageData
  $: ({ lang, sections, faqs, formattedFaqs } = data)
</script>

<StructuredData
  schema={{
    '@type': 'FAQPage',
    mainEntity: formattedFaqs,
  }}
/>
<h1>{FAQ_STRINGS[lang].TITLE}</h1>
<section>
  <Faq {faqs} {sections} search contact />
</section>

<style lang="scss">
  @use '@bruce/assets/css/breakpoints';

  section {
    max-width: 800px;
    width: 100%;

    @media screen and (max-width: breakpoints.$breakpoint-md) {
      width: calc(100% - 32px);
    }
  }
</style>
